// extracted by mini-css-extract-plugin
export var container = "SheetTemplateLinks-module--container--9ebae";
export var heading = "SheetTemplateLinks-module--heading--5856b";
export var link = "SheetTemplateLinks-module--link--87f68";
export var links = "SheetTemplateLinks-module--links--7f60f";